/**
 * Display helpers for classroom name + grade.
 *
 * Teachers may type either "12" or "Room 12" in the classroom name field
 * (and "5" or "Grade 5" for grade). The take-home sheet PDF normalizes
 * both forms so parents always see "Room 12 · Grade 5". These helpers
 * apply the same normalization everywhere else in the UI.
 *
 * Mirrors Classroom#display_name / Classroom#display_grade on the server.
 * Use the raw `name` / `grade` for form inputs; use these for display.
 */
export function formatRoom(name) {
  if (!name || !String(name).trim()) return name;
  return `Room ${String(name).replace(/^\s*Room\s+/i, "").trim()}`;
}

export function formatGrade(grade) {
  if (!grade || !String(grade).trim()) return grade;
  return `Grade ${String(grade).replace(/^\s*Grade\s+/i, "").trim()}`;
}

/**
 * The division a new classroom starts in, from its grade: K–3 is
 * Division 1, 4–6 Division 2, 7–9 Division 3, 10–12 Division 4. Split
 * classes take their first grade. Mirrors Classrooms::DefaultDivision.
 */
export function defaultDivision(grade) {
  const text = String(grade || "").toLowerCase();
  if (/\b(k|jk|sk|kg|kindergarten|pre-?k)\b/.test(text)) return "Division 1";

  const match = text.match(/\d+/);
  if (!match) return "";
  const n = Number(match[0]);
  if (n <= 3) return "Division 1";
  if (n <= 6) return "Division 2";
  if (n <= 9) return "Division 3";
  if (n <= 12) return "Division 4";
  return "";
}
